import type { AvailableThemeKey } from './available-theme-keys.type';
import { availableThemes } from './available-themes.const';

/**
 * Returns the theme for the given key.
 * @param key
 */
export const getTheme = (key: AvailableThemeKey) => availableThemes[key];
